import request from '@/utils/request'
import qs from 'qs'

export function userLogin(email, password) {
  return request({
    url: '/auth/local',
    method: 'post',
    data: qs.stringify({ 'email': email, 'password': password })
  })
}



export function getResources(book, params) {
  return request({
    url: '/api/v1/books/' + book + '/resources',
    params: params,
    method: 'get'
  })
}

export function getBooks(params) {
  return request({
    url: '/api/v1/books',
    params: params,
    method: 'get'
  })
}

export function getResourceDetail(id) {
  return request({
    url: '/api/v1/dgs/resources/' + id,
    method: 'get'
  })
}

export function getBookInfo(params) {
  return request({
    url: '/api/v1/books/guess',
    params: params,
    method: 'get'
  })
}

export function getBookDetail(ID) {
  return request({
    url: '/api/v1/books/' + ID,
    method: 'get'
  })
}

export function getProtectContent(bookID,resourceID){
  return request({
    url: '/api/v1/books/'+bookID+'/resources/'+resourceID+'/protectContent',
    method: 'get'
  })
}

export function isBuy(book, resource) {
  return request({
    url: '/api/v1/books/' + book + '/resources/' + resource + '/buyCheck',
    method: 'get'
  })
}